(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-enhanced"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.product-enhanced').forEach(function(section) {
    var productId = section.dataset.productId;
    var dataEl = document.getElementById('product-data-' + productId);
    if (!dataEl) return;
    var productData = JSON.parse(dataEl.textContent);
    var variantData = productData.variants;
    var strings = productData.strings;

    var thumbs = section.querySelectorAll('.product-enhanced__thumb');
    var items = section.querySelectorAll('.product-enhanced__media-item');

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(thumb.dataset.index, 10);
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        items.forEach(function(i) { i.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (items[idx]) items[idx].classList.add('is-active');
      });
    });

    var qtyInput = section.querySelector('.product-enhanced__qty-input');
    section.querySelectorAll('.product-enhanced__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (btn.dataset.action === 'increase') {
          qtyInput.value = val + 1;
        } else if (btn.dataset.action === 'decrease' && val > 1) {
          qtyInput.value = val - 1;
        }
      });
    });

    var optionInputs = section.querySelectorAll('.product-enhanced__option-input');
    var variantIdInput = section.querySelector('[id^="variant-id-"]');
    var addBtn = section.querySelector('.product-enhanced__add-btn');
    var priceEl = section.querySelector('[id^="price-"]');

    function getSelectedOptions() {
      var opts = {};
      optionInputs.forEach(function(inp) {
        if (inp.checked) opts[inp.name] = inp.value;
      });
      return Object.values(opts);
    }

    function findVariant(selectedOpts) {
      return variantData.find(function(v) {
        return v.options.every(function(opt, i) { return opt === selectedOpts[i]; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    function updatePrice(variant) {
      if (!priceEl || !variant) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var saved = variant.compare_at_price - variant.price;
        priceEl.innerHTML =
          '<span class="product-enhanced__price-sale">' + formatMoney(variant.price) + '<\/span>' +
          '<s class="product-enhanced__price-compare">' + formatMoney(variant.compare_at_price) + '<\/s>' +
          '<span class="product-enhanced__badge">Save ' + formatMoney(saved) + '<\/span>';
      } else {
        priceEl.innerHTML = '<span class="product-enhanced__price-regular">' + formatMoney(variant.price) + '<\/span>';
      }
    }

    optionInputs.forEach(function(inp) {
      inp.addEventListener('change', function() {
        var selected = getSelectedOptions();
        var variant = findVariant(selected);
        if (variant && variantIdInput) variantIdInput.value = variant.id;
        if (variant && addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-disabled');
            addBtn.textContent = strings.add_to_cart;
          } else {
            addBtn.disabled = true;
            addBtn.classList.add('is-disabled');
            addBtn.textContent = strings.sold_out;
          }
        }
        updatePrice(variant);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
